import { dataExternalLink } from 'dls-icons-data'
import { createIcon } from '../common'

const IconExternalLink = /*#__PURE__*/createIcon(dataExternalLink)
export default IconExternalLink
